import { Link } from "react-router-dom";

const Icons = ({ cname, src, link, children }) => {
  return (
    <Link
    to={link}
    className="boxShadow flex flex-col items-center justify-center group p-2 rounded-2xl bg-[aliceblue] transition duration-500 hover:scale-110"
  >
    <div className="flex items-center justify-center">
      {src && (
        <img
          width={150}
          height={100}
          src={src}
          alt="image"
          className="rounded-lg"
        />
      )}
      {children}
    </div>
    <span className="mt-1 text-xs font-semibold text-center text-gray-900 duration-200 md:text-sm md:font-bold group-hover:text-blue-600 md:mt-4 whitespace-nowrap ">
      {cname}
    </span>
  </Link>
  
  );
};

export default function Categories() {
  return (
    // <Container>
      <div className="w-full pt-3 pb-4 text-black bg-white shadow-lg">
        {/* <MotionAnimation> */}
          {/* <p className="px-5 text-lg font-semibold">Shop By Catgories</p> */}
          <div className="flex items-start justify-between gap-1 py-6 overflow-y-scroll md:px-5 lg:px-10 md:gap-9 md:overflow-y-hidden noScrollBar">
            <Icons src={"./image/home/1Ideology.jpg"} cname={"Ideology"} link={"/ideology"} />
            <Icons src={"./image/home/legacy-2.jpg"} cname={"Legacy"} link={"/lagacy"} />
            <Icons src={"./image/home/33Sprituality.jpg"} cname={"Practical Sprituality"} link={"/spirituality"} />
            <Icons src={"./image/home/444GlobalMission.jpg"} cname={"Global Mission"} link={"/GlobalMision"} />
            <Icons src={"./image/home/nirankari-samagams.jpg"} cname={"Nirankari Samangam"} link={"/nirankariSamagams"} />
            <Icons src={"./image/home/66CommunityService.jpeg"} cname={"Community Service"} link={"/communityService"} />
          </div>
          <div className="flex items-start justify-between gap-5 pt-3 pb-4 mx-2 overflow-y-scroll md:px-5 lg:px-10 md:gap-9 md:overflow-y-hidden noScrollBar">
          <Icons src={"./image/home/news-1.jpg"} cname={"News"} link={"/news"} />
          <Icons src={"./image/home/music-1.jpg"} cname={"Music"} link={"/music"} />
            <Icons src={"./image/home/LandmarkEvents.jpg"} cname={"Landmark Event"} link={"/landmarkEvent"} />
            <Icons src={"./image/home/StudioDevine2.jpg"} cname={"Studio Devine"} link={"/studioDevine"} />
            <Icons src={"./image/home/podcasts-1.jpg"} cname={"Podcasts"} link={"/podcasts"} />
            <Icons src={"./image/home/12Publication.jpg"} cname={"Publication"} link={"/publication"} />
          </div>
        {/* </MotionAnimation> */}
      </div>
    // </Container>
  );
}
